import ApiServiceError from './ApiServiceError';

export const DATASOURCES = {
  ME: 'me',
};

export const getDataSource = (state, name) => {
  const { dataSources } = state.app;

  let dataSource = {
    isFetching: false,
  };

  if (dataSources[name]) {
    dataSource = dataSources[name];
  }

  return dataSource;
};

export function parseResponse(payload) {
  const { errors } = payload;
  if (errors) {
    throw new ApiServiceError(errors[0].status, errors[0]);
  }
  return payload;
}



// WEBPACK FOOTER //
// ./src/state/services/utils.js